import CircularProgress from "@mui/material/CircularProgress";
import { StyledTooltip } from "../../toolltipComponent";

const IconButtonTable = ({
  icon = "",
  onClick,
  rowData,
  isLoading = false,
  hideCondition = () => false,
  background = "transparent",
  iconSize = "15px",
  tootip= "",
}) => {
  const shouldHide =
    typeof hideCondition === "function"
      ? hideCondition(rowData)
      : hideCondition;

  if (shouldHide) return null;

  const loading =
    typeof isLoading === "function" ? isLoading(rowData) : isLoading;

  return (
    <StyledTooltip
      title={
        <>
          <div className="HContainer">
            <p className="toolkit-title">{tootip}</p>
          </div>
        </>
      }
      followCursor
    >
      <div
        className={`eye-btn ${loading ? "disabled" : ""}`}
        onClick={() => {
          if (!loading && onClick) onClick(rowData);
        }}
        style={{
          pointerEvents: loading ? "none" : "auto",
          opacity: loading ? 0.6 : 1,
          background,
          borderRadius: "20px",
          padding: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "36px",
          height: "36px"
        }}
      >
        {loading ? (
          <CircularProgress size={15} thickness={5} />
        ) : (
          <img
            className="btn-icon-table"
            src={icon}
            alt="icon"
            style={{ width: iconSize }}
          />
        )}
      </div>
    </StyledTooltip>
  );
};

export default IconButtonTable;
